import { render, staticRenderFns } from "./RepairExtension.vue?vue&type=template&id=13199c32&scoped=true"
import script from "./RepairExtension.vue?vue&type=script&lang=js"
export * from "./RepairExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13199c32",
  null
  
)

export default component.exports